import Cookies from 'js-cookie'
import { handleSessionExpired } from '@/lib/authToken'
import type { CommunicationGuidelinesRecord, CommunicationGuidelines } from '../types'

const API_BASE = (import.meta.env?.VITE_API_URL as string) || ''

function buildUrl(path: string) {
  if (API_BASE) return `${API_BASE.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
  return path.startsWith('/') ? path : `/${path}`
}

export class ApiError extends Error {
  code?: string
  constructor(message: string, code?: string) {
    super(message)
    this.name = 'ApiError'
    this.code = code
  }
}

async function apiFetch<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = Cookies.get('token')
  const headers: Record<string, string> = {}
  if (body !== undefined) headers['Content-Type'] = 'application/json'
  if (token) headers.Authorization = `Bearer ${token}`
  const res = await fetch(buildUrl(path), {
    method,
    headers,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  })
  if (!res.ok) {
    if (res.status === 401 && token) {
      handleSessionExpired()
      throw new ApiError('Session expired')
    }
    const p = await res.json().catch(() => null)
    const details = Array.isArray(p?.error?.details) ? p.error.details : null
    const detailMessage = details?.length
      ? details.map((d: { field?: string; message?: string }) => d.message || d.field).join('; ')
      : null
    const message = detailMessage || p?.error?.message || p?.message || res.statusText || 'Request failed'
    throw new ApiError(message, p?.error?.code)
  }
  if (res.status === 204) return undefined as T
  return res.json()
}

export function getCommunicationGuidelines(workspaceId: string): Promise<CommunicationGuidelinesRecord> {
  return apiFetch('GET', `/api/workspaces/${workspaceId}/communication-guidelines`)
}

export function upsertCommunicationGuidelines(workspaceId: string, input: CommunicationGuidelines): Promise<CommunicationGuidelinesRecord> {
  return apiFetch('PUT', `/api/workspaces/${workspaceId}/communication-guidelines`, input)
}
